export default {
  "nav.home": "Home",
  "nav.categories": "Categories",
  "nav.guides": "Guides",
  "nav.faq": "FAQ",
  "nav.shopGuide": "Shopping Guide",

  "hero.badge": "USFans Spreadsheet Resource Hub",
  "hero.title": "USFans Spreadsheet — Find Products, Sellers & Buying Resources Faster",
  "hero.subtitle": "Explore USFans Spreadsheet resources, seller guides, product research, QC, shipping costs, warehouse information, reviews, coupons and safety guides — all organized in one place.",
  "hero.ctaPrimary": "Explore USFans Spreadsheet",
  "hero.ctaSecondary": "Browse USFans Guides",
  "hero.note": "Browse categories below and jump straight to the main store.",

  "cat.title": "Browse Product Categories",
  "cat.subtitle": "Pick a category to open it on the main website. Use the dropdown or tap a button below.",
  "cat.dropdownLabel": "Choose a category",
  "cat.dropdownPlaceholder": "Select a category…",
  "cat.open": "Open on main site",

  "cat.shoes": "Shoes",
  "cat.hoodies": "Hoodies/Sweaters",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jackets",
  "cat.pants": "Pants/Shorts",
  "cat.headwear": "Headwear",
  "cat.sets": "Sets",
  "cat.underwear": "Underwear/Underpants",
  "cat.jersey": "Jersey",
  "cat.accessories": "Accessories",
  "cat.bags": "Bags",
  "cat.belts": "Belts",
  "cat.perfumes": "Perfumes",
  "cat.other": "Other Stuff",

  "about.title": "What Is USFans Spreadsheet?",
  "about.p1": "USFans Spreadsheet is an organized catalog that groups shoes, hoodies, t-shirts, jerseys, accessories and more into a single, easy-to-browse list. Instead of hunting through a full store, you can jump straight to the section you want.",
  "about.p2": "It is built to save time — compare products side by side, check seller notes, and understand shipping before you buy. Think of it as a research shortcut that points you to the right products on the main website.",

  "features.title": "Popular USFans Resources",
  "features.subtitle": "Guides that help you buy smarter and stay safe.",
  "features.review.title": "USFans Review",
  "features.review.desc": "What buyers say about products, sellers and the overall experience.",
  "features.shipping.title": "Shipping Cost",
  "features.shipping.desc": "Understand shipping options, warehouse info and delivery times.",
  "features.coupon.title": "Coupon & Discount",
  "features.coupon.desc": "Tips on finding savings, coupons and discount codes.",
  "features.safety.title": "Safety & Legit",
  "features.safety.desc": "Is USFans legit? Practical safety and verification tips.",

  "guides.title": "Latest Guides",
  "guides.subtitle": "Original, in-depth articles built around USFans Spreadsheet.",
  "guides.readMore": "Read article",

  "cta.title": "Ready to shop the full catalog?",
  "cta.subtitle": "Open the main USFans store to browse every product, see current prices and complete your order.",
  "cta.primary": "USFans Spreadsheet",
  "cta.secondary": "Buy It Now",

  "faq.title": "Frequently Asked Questions",
  "faq.q1": "What is USFans Spreadsheet?",
  "faq.a1": "It is an organized product catalog that groups streetwear and fan merchandise by category, linking to the main store for purchases.",
  "faq.q2": "Is it free to browse?",
  "faq.a2": "Yes, browsing the categories is straightforward. Pricing and checkout happen on the main website.",
  "faq.q3": "How do I buy an item?",
  "faq.a3": "Pick a category, open it on the main website, and complete your order there.",
  "faq.q4": "Is USFans legit?",
  "faq.a4": "Always verify the official store, payment methods and policies before purchasing, and avoid look-alike websites.",

  "footer.tagline": "An independent informational resource about USFans Spreadsheet.",
  "footer.explore": "Explore",
  "footer.resources": "Resources",
  "footer.mainSite": "Main website",
  "footer.disclaimer": "This website is an independent informational resource. Information may change over time. Always verify important information before making a purchase, payment or sharing personal information.",
  "footer.rights": "All rights reserved.",
};